/* eslint-disable no-console */
import React, { Component } from 'react';
import { ThemeProvider, defaultTheme, LoadingScreen} from '@nike/ruxac';
import './Styles/App.css';
import Header from './Components/Header';
import 'react-table-filter/lib/styles.css';
import './Styles/styles.scss';
import Sticky from 'react-stickynode';
import {connect} from 'react-redux';
import TableGridContainer from './Components/TableGridContainer';
import ErrorMessage from './Components/ErrorMessage';
import 'react-table-filter/lib/styles.css';
import 'normalize.css/normalize.css';
import '@nike/ruxac/fonts';
import '@nike/ruxac/styles';
import {loadDataFromAPI} from './APIs/dataHelper';
import {checkForToken, login} from './APIs/loginHelper';
import {setLoadingIndicator} from './Actions/loading';
import {setErrorState} from './Actions/errorHandler';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data       : [],
            errorCheck : false,
            authCheck  : false
        };
    }


    async componentDidMount() {
        const id = location.search.split('id=')[1];
        if(id)
            localStorage.setItem ('id', id);
        const jwt = checkForToken ();
        if (!jwt || !jwt.accessToken) {
            //redirect to SSO if detects query string has been entered and no jwt present
            login ();
        }
        else {
            this.props.setLoadingIndicator(true);
            const dataLoading = await this.getData(jwt.accessToken,id);
            if(dataLoading.status == 200){
                this.setState({
                    data      : dataLoading.data,
                    authCheck : true
                });
                this.props.setLoadingIndicator(false);
            }
            else{
                this.setState({
                    errorCheck : true,
                    authCheck  : false
                });

                switch(dataLoading) {
                    case 400:
                        this.props.setErrorState({code : dataLoading.status, message : 'You are Missing Nike Dev Style Season ID'});
                        break;
                    case 401:
                        this.props.setErrorState({code : dataLoading.status, message : 'You are not authorized to use this application.'});
                        break;
                    case 502:
                        this.props.setErrorState({code : dataLoading.status, message : 'Server Unavailable -  Please Try Refreshing the Page'});
                        break;
                    case 500:
                        this.props.setErrorState({code : dataLoading.status, message : 'Server Unavailable -  Please Try Refreshing the Page'});
                        break;
                    default:
                        break;
                }

                this.props.setLoadingIndicator(false);
            }

        }
    }
    getData(token, id) {
        return new Promise ((resolve) => {
            resolve(loadDataFromAPI(token, id));
        });
    }

    render() {
        const isLoadingState = this.props.loadingIndicator.isLoadingData;
        const devStyleName = (this.state.data[0] && this.state.data[0].styleName)?this.state.data[0].styleName  : '';
        return (
            <ThemeProvider theme={defaultTheme}>
                <div className="container-app">
                    <Sticky
                        enabled={true}
                        top={0}
                        innerZ={1000}
                    >
                        <Header />
                    </Sticky>
                    <LoadingScreen
                        isLoading={isLoadingState}
                        loadingMessage='Loading Data'
                    />
                    <div>
                        <div className={`grid-container`}>
                            {!isLoadingState && !this.state.errorCheck && this.state.authCheck  && this.state.data.length > 0 &&(
                                <div className={`shadowBox tableGrid-container-sc`}>
                                    <TableGridContainer
                                        title={devStyleName}
                                        data={this.state.data}
                                        name='srcChange'
                                    />
                                </div>
                            )}
                            {!isLoadingState && !this.state.errorCheck && this.state.authCheck
                            && this.state.data.length === 0 &&(
                                <div>
                                    <ErrorMessage
                                        message="No records found"
                                    />
                                </div>
                            )}
                            {!isLoadingState && this.state.errorCheck && !this.state.authCheck &&(
                                <div>
                                    <ErrorMessage
                                        message={this.props.error.message}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        data             : state.data.payload,
        loadingIndicator : state.loadingIndicator,
        error            : state.errorHandler

    };
};
const mapDispatchProps = {
    setLoadingIndicator,
    loadDataFromAPI,
    setErrorState
};
export default connect(mapStateToProps, mapDispatchProps)(App);



// WEBPACK FOOTER //
// ./src/App.js